// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"m2-z"};